/*
 * @Author: Teemo Ding
 * @Date: 2021-10-11 15:47:12
 * @LastEditTime: 2021-10-13 14:04:54
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/CourierAccount/CourierAccountInformation/index.tsx
 */
import { Input, Label } from '@/src/components/Antd';
import { Form } from 'antd';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import styles from '../style.module.less';

const RenderValue = (props) => {
  const { value } = props;
  return <div>{value}</div>;
};
const CourierAccountInformation = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div className={styles.itemBlock}>
      <div className={styles.header}>
        <div className={styles.title}>
          {getI18n('storeLogistics.courierAccount.courierAccountInformation')}
        </div>
      </div>
      <div className={`${styles.itemContent} ${styles.content}`}>
        <div className={styles.formItemTwoInOne}>
          <Form.Item
            className={styles.formItemTwoInOneItem}
            label={
              <Label
                title={`${getI18n(
                  'storeLogistics.courierAccount.courierAccountName',
                )}*`}
                rightSubTitle={getI18n(
                  'storeLogistics.warehouseLocations.forinternalreference',
                )}
                textLength={100}
                nameKey='name'
              />
            }
            name={'name'}
            rules={[
              {
                required: true,
                message: replaceI18nVariables(
                  getI18n('general.fieldisrequired'),
                  getI18n('storeLogistics.courierAccount.courierAccountName'),
                ),
              },
            ]}>
            <Input size='large' maxLength={100} />
          </Form.Item>
          <Form.Item
            className={styles.formItemTwoInOneItem}
            label={
              <Label
                title={getI18n('storeLogistics.courierAccount.courierVendor')}
              />
            }
            name={'title'}>
            <RenderValue />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default CourierAccountInformation;
